










import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import * as types from "@/store/constants/index_types";
import { isIos } from "@/utils/lodash";
@Component({
  components: {}
})
export default class ManageEntrance extends Vue {
  @Getter(types.GETTER_CURRENT_USER_ID)
  private currentUserId: any;
  private clickMore() {
    this.$emit("click");
  }
  get needBind() {
    return false;
  }

  get isIOS() {
    return isIos();
  }

  get entranceName() {
    return this.currentUserId ? "Manage Accounts" : "Add Accounts";
  }
}
